<div class="row lg-flex">
  <div class="column twelve flex-min-0"><ng-content select="div.main"></ng-content></div>
  @if (sidebarVisible) {
    <div #sidebar class="column twelve aside-wrapper">
      <ng-content select="aside.main-aside"></ng-content>
    </div>
  }
</div>
